import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ImageIcon, VideoIcon, ImageUp, MonitorUp } from "lucide-react";

const Newproject = () => {
  const formik = useFormik({
    initialValues: {
      car_image: null,
    },
    validationSchema: Yup.object({
      car_image: Yup.mixed()
        .required('A file is required')
        .test('fileSize', 'File is too large', value => !value || value.size <= 1024 * 1024)
        .test('fileType', 'Unsupported file format', value =>
          !value || ['image/jpeg', 'image/png'].includes(value.type)
        ),
    }),
    onSubmit: values => {
      console.log(values);
      alert('تم ارسال بيانات النموذج')
    },
  });

  const handleFileChange = (e) => {
    const file = e.currentTarget.files[0];
    formik.setFieldValue('car_image', file);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <label htmlFor="car_image" style={{ cursor: 'pointer' }}>
       <ImageUp size={46}/>
      </label>
      <br />
      <input
        id="car_image"
        name="car_image"
        type="file"
        style={{ display: 'none' }}
        onChange={handleFileChange}
        onBlur={formik.handleBlur}
      />
      {formik.errors.car_image && formik.touched.car_image ? (
        <div style={{ color: 'red' }}>{formik.errors.car_image}</div>
      ) : null}
      <button type="submit">Submit</button>
    </form>
  );
};

export default Newproject;
